import { SettingsRoutes } from 'pages/settings/route/type'
import { IntegrationsRoutes } from './type'

const integrations = `${SettingsRoutes.root}/${IntegrationsRoutes.root}`

export const IntegrationsPath = {
  root: integrations,
}
